export default {
  en: {
    goals: {
      confidence_work: 'Speak more confidently at work',
      new_job: 'Find a new job',
      live_abroad: 'Live abroad comfortably',
      travel: 'Travel freely',
      self_growth: 'Build the skill for myself',
      connect: 'Connect with friends and family',
    },
    speakingDifficulties: {
      freeze: 'I freeze up and go silent',
      find_words: "I can't find the right words",
      grammar: "I'm afraid of making grammar mistakes",
      slow: 'It takes me a long time to form a reply',
      accent: 'People struggle to understand my pronunciation',
      none: 'None of these',
    },
    dailyUsage: {
      news: 'Read the news',
      shows: 'Watch shows and videos',
      music: 'Listen to music and podcasts',
      work: 'Use it at work',
      chat: 'Chat with native speakers',
      rarely: 'Barely use it',
    },
    workFields: {
      tech: 'IT and engineering',
      business: 'Business and finance',
      education: 'Studying / education',
      creative: 'Creative and media',
      services: 'Services and trades',
      marketing: 'Marketing and sales',
      healthcare: 'Healthcare and science',
      unemployed: 'Currently not working',
      other: 'Other',
    },
    ageRanges: {
      lt18: 'Under 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Male',
      female: 'Female',
      skip: "Doesn't matter",
    },
    currentMethods: {
      courses: 'Courses or a tutor',
      apps: 'Language-learning apps',
      videos: 'Videos and movies',
      podcasts: 'Podcasts and audiobooks',
      speaking: 'Speaking practice',
      none: 'Not learning right now',
    },
    challenges: {
      time: 'Not enough time',
      motivation: 'Hard to stay motivated',
      few_chances: 'Few chances to speak',
      forget: "I forget what I've learned",
      nervous: 'I get nervous when speaking',
      too_hard: 'The language feels too hard',
      none: 'No real difficulties',
    },
    speakingFeelings: {
      anxious: 'I get anxious and sweat',
      freeze: 'I freeze and forget words',
      avoid: 'I try to avoid speaking situations',
      embarrassed: "I speak, but I'm embarrassed",
      confident: 'I feel confident',
    },
    mistakeFears: {
      a_lot: "Yes, a lot — so I'd rather stay silent",
      a_little: 'A little, it feels awkward',
      no: "No, mistakes don't scare me",
    },
    vocabGaps: {
      often: 'Yes, I often run out of words',
      sometimes: 'Sometimes',
      no: 'No, I have enough words',
    },
    progressQuits: {
      many_times: 'Yes, more than once',
      once: 'It happened once',
      no: 'No, never',
    },
    hardestParts: {
      starting: 'Starting a conversation',
      flow: 'Speaking without stumbling',
      words: 'Quickly finding the right words',
      accents: 'Understanding different accents',
      complex: 'Expressing complex thoughts',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Beginner',
        sublabel: 'I can buy things and order food',
      },
      B1: {
        label: 'Intermediate',
        sublabel: 'I can hold a simple everyday conversation',
      },
      B2: {
        label: 'Upper-intermediate',
        sublabel: 'I can join a discussion and explain my point of view',
      },
      'C1-C2': {
        label: 'Advanced',
        sublabel: 'I speak confidently in any situation, including work',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Lifestyle',
        shopping: 'Shopping',
        cooking: 'Cooking',
        yoga: 'Yoga',
        fashion: 'Fashion',
        fitness: 'Fitness',
        beauty: 'Beauty',
        pets: 'Pets',
        parenting: 'Parenting',
        food: 'Food',
        dating: 'Dating',
        relationships: 'Relationships',
        cars: 'Cars',
      },
      artsCulture: {
        title: 'Arts & Culture',
        music: 'Music',
        history: 'History',
        handcraft: 'Handicrafts',
        literature: 'Literature',
        art: 'Art',
        photography: 'Photography',
        content_creation: 'Content creation',
      },
      activeLife: {
        title: 'Active Life',
        sports: 'Sports',
        travelling: 'Travel',
        dancing: 'Dancing',
        biking: 'Cycling',
        football: 'Football',
        weight_lifting: 'Gym',
        hiking: 'Hiking',
        running: 'Running',
        swimming: 'Swimming',
      },
      entertainment: {
        title: 'Entertainment',
        movies: 'Movies',
        tv_shows: 'TV shows',
        gaming: 'Gaming',
        social_media: 'Social media',
        podcasts: 'Podcasts',
        chatting: 'Chatting',
        news: 'News',
        anime: 'Anime',
        sci_fi: 'Sci-fi',
        fantasy: 'Fantasy',
        comedy: 'Comedy',
        horror: 'Horror',
        memes: 'Memes',
      },
      workGrowth: {
        title: 'Work & Growth',
        interview: 'Interviews',
        tech: 'Technology',
        finance: 'Finance',
        management: 'Management',
        ai: 'AI',
        business: 'Business',
        startups: 'Startups',
      },
    },
    agreementChoices: {
      yes: 'Yes',
      maybe: 'Maybe',
      no: 'No',
    },
    // Слова словарной проверки не переводятся — одинаковы в обеих локалях.
  },
  ru: {
    goals: {
      confidence_work: 'Увереннее говорить на работе',
      new_job: 'Найти новую работу',
      live_abroad: 'Комфортно жить за границей',
      travel: 'Свободно путешествовать',
      self_growth: 'Прокачать навык для себя',
      connect: 'Общаться с друзьями и семьёй',
    },
    speakingDifficulties: {
      freeze: 'Теряюсь и молчу',
      find_words: 'Не могу подобрать нужные слова',
      grammar: 'Боюсь ошибиться в грамматике',
      slow: 'Долго формулирую ответ',
      accent: 'Меня плохо понимают из-за произношения',
      none: 'Ничего из этого',
    },
    dailyUsage: {
      news: 'Читаю новости',
      shows: 'Смотрю сериалы и видео',
      music: 'Слушаю музыку и подкасты',
      work: 'Использую на работе',
      chat: 'Переписываюсь с носителями',
      rarely: 'Почти не использую',
    },
    workFields: {
      tech: 'IT и инженерия',
      business: 'Бизнес и финансы',
      education: 'Учусь / образование',
      creative: 'Творчество и медиа',
      services: 'Услуги и мастерство',
      marketing: 'Маркетинг и продажи',
      healthcare: 'Медицина и наука',
      unemployed: 'Сейчас без работы',
      other: 'Другое',
    },
    ageRanges: {
      lt18: 'до 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Мужской',
      female: 'Женский',
      skip: 'Неважно',
    },
    currentMethods: {
      courses: 'Курсы или репетитор',
      apps: 'Приложения для языков',
      videos: 'Видео и фильмы',
      podcasts: 'Подкасты и аудиокниги',
      speaking: 'Разговорная практика',
      none: 'Сейчас не учу',
    },
    challenges: {
      time: 'Не хватает времени',
      motivation: 'Сложно сохранять мотивацию',
      few_chances: 'Мало возможностей говорить',
      forget: 'Забываю пройденное',
      nervous: 'Нервничаю, когда говорю',
      too_hard: 'Язык кажется слишком сложным',
      none: 'Особых сложностей нет',
    },
    speakingFeelings: {
      anxious: 'Волнуюсь и потею',
      freeze: 'Теряюсь и забываю слова',
      avoid: 'Стараюсь избегать разговора',
      embarrassed: 'Говорю, но стесняюсь',
      confident: 'Чувствую себя уверенно',
    },
    mistakeFears: {
      a_lot: 'Да, очень — поэтому лучше промолчу',
      a_little: 'Немного, бывает неловко',
      no: 'Нет, ошибки меня не пугают',
    },
    vocabGaps: {
      often: 'Да, часто не хватает слов',
      sometimes: 'Иногда',
      no: 'Нет, слов хватает',
    },
    progressQuits: {
      many_times: 'Да, и не раз',
      once: 'Было один раз',
      no: 'Нет, не бросал',
    },
    hardestParts: {
      starting: 'Начать разговор',
      flow: 'Говорить без запинок',
      words: 'Быстро находить нужные слова',
      accents: 'Понимать разные акценты',
      complex: 'Выражать сложные мысли',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Начальный',
        sublabel: 'Могу купить что-то и заказать еду',
      },
      B1: {
        label: 'Средний',
        sublabel: 'Могу поддержать простой разговор на бытовые темы',
      },
      B2: {
        label: 'Выше среднего',
        sublabel: 'Могу участвовать в обсуждении и объяснять свою точку зрения',
      },
      'C1-C2': {
        label: 'Продвинутый',
        sublabel: 'Уверенно говорю в любой ситуации, включая работу',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Образ жизни',
        shopping: 'Шопинг',
        cooking: 'Готовка',
        yoga: 'Йога',
        fashion: 'Мода',
        fitness: 'Фитнес',
        beauty: 'Красота',
        pets: 'Питомцы',
        parenting: 'Родительство',
        food: 'Еда',
        dating: 'Свидания',
        relationships: 'Отношения',
        cars: 'Машины',
      },
      artsCulture: {
        title: 'Искусство и культура',
        music: 'Музыка',
        history: 'История',
        handcraft: 'Рукоделие',
        literature: 'Литература',
        art: 'Искусство',
        photography: 'Фотография',
        content_creation: 'Создание контента',
      },
      activeLife: {
        title: 'Активная жизнь',
        sports: 'Спорт',
        travelling: 'Путешествия',
        dancing: 'Танцы',
        biking: 'Велосипед',
        football: 'Футбол',
        weight_lifting: 'Тренажёрный зал',
        hiking: 'Походы',
        running: 'Бег',
        swimming: 'Плавание',
      },
      entertainment: {
        title: 'Развлечения',
        movies: 'Фильмы',
        tv_shows: 'Сериалы',
        gaming: 'Игры',
        social_media: 'Соцсети',
        podcasts: 'Подкасты',
        chatting: 'Общение',
        news: 'Новости',
        anime: 'Аниме',
        sci_fi: 'Фантастика',
        fantasy: 'Фэнтези',
        comedy: 'Комедии',
        horror: 'Хорроры',
        memes: 'Мемы',
      },
      workGrowth: {
        title: 'Работа и развитие',
        interview: 'Собеседования',
        tech: 'Технологии',
        finance: 'Финансы',
        management: 'Менеджмент',
        ai: 'AI',
        business: 'Бизнес',
        startups: 'Стартапы',
      },
    },
    agreementChoices: {
      yes: 'Да',
      maybe: 'Может быть',
      no: 'Нет',
    },
  },
  de: {
    goals: {
      confidence_work: 'Sicherer im Job sprechen',
      new_job: 'Einen neuen Job finden',
      live_abroad: 'Bequem im Ausland leben',
      travel: 'Unbeschwert reisen',
      self_growth: 'Die Fähigkeit für mich selbst aufbauen',
      connect: 'Mit Freunden und Familie in Kontakt bleiben',
    },
    speakingDifficulties: {
      freeze: 'Ich blockiere und schweige',
      find_words: 'Ich finde nicht die richtigen Worte',
      grammar: 'Ich habe Angst, Grammatikfehler zu machen',
      slow: 'Ich brauche lange, um eine Antwort zu formulieren',
      accent: 'Meine Aussprache ist für andere schwer zu verstehen',
      none: 'Nichts davon',
    },
    dailyUsage: {
      news: 'Ich lese Nachrichten',
      shows: 'Ich schaue Serien und Videos',
      music: 'Ich höre Musik und Podcasts',
      work: 'Ich nutze es im Job',
      chat: 'Ich chatte mit Muttersprachlern',
      rarely: 'Ich nutze es kaum',
    },
    workFields: {
      tech: 'IT und Ingenieurwesen',
      business: 'Business und Finanzen',
      education: 'Studium / Bildung',
      creative: 'Kreatives und Medien',
      services: 'Dienstleistungen und Handwerk',
      marketing: 'Marketing und Vertrieb',
      healthcare: 'Medizin und Wissenschaft',
      unemployed: 'Aktuell ohne Job',
      other: 'Sonstiges',
    },
    ageRanges: {
      lt18: 'Unter 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Männlich',
      female: 'Weiblich',
      skip: 'Egal',
    },
    currentMethods: {
      courses: 'Kurse oder ein Tutor',
      apps: 'Sprachlern-Apps',
      videos: 'Videos und Filme',
      podcasts: 'Podcasts und Hörbücher',
      speaking: 'Sprechübungen',
      none: 'Lerne gerade nicht',
    },
    challenges: {
      time: 'Zu wenig Zeit',
      motivation: 'Schwer, motiviert zu bleiben',
      few_chances: 'Wenig Gelegenheit zum Sprechen',
      forget: 'Ich vergesse, was ich gelernt habe',
      nervous: 'Ich werde beim Sprechen nervös',
      too_hard: 'Die Sprache fühlt sich zu schwer an',
      none: 'Keine großen Schwierigkeiten',
    },
    speakingFeelings: {
      anxious: 'Ich werde nervös und schwitze',
      freeze: 'Ich blockiere und vergesse Wörter',
      avoid: 'Ich versuche, Sprechsituationen zu vermeiden',
      embarrassed: 'Ich spreche, aber es ist mir unangenehm',
      confident: 'Ich fühle mich sicher',
    },
    mistakeFears: {
      a_lot: 'Ja, sehr — deshalb schweige ich lieber',
      a_little: 'Ein wenig, es ist mir unangenehm',
      no: 'Nein, Fehler machen mir keine Angst',
    },
    vocabGaps: {
      often: 'Ja, mir gehen oft die Wörter aus',
      sometimes: 'Manchmal',
      no: 'Nein, ich habe genug Wörter',
    },
    progressQuits: {
      many_times: 'Ja, mehr als einmal',
      once: 'Einmal ist es vorgekommen',
      no: 'Nein, nie',
    },
    hardestParts: {
      starting: 'Ein Gespräch beginnen',
      flow: 'Ohne Stolpern sprechen',
      words: 'Schnell die richtigen Wörter finden',
      accents: 'Verschiedene Akzente verstehen',
      complex: 'Komplexe Gedanken ausdrücken',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Anfänger',
        sublabel: 'Ich kann einkaufen und Essen bestellen',
      },
      B1: {
        label: 'Mittelstufe',
        sublabel: 'Ich kann ein einfaches Alltagsgespräch führen',
      },
      B2: {
        label: 'Gehobenes Niveau',
        sublabel: 'Ich kann an Diskussionen teilnehmen und meine Sichtweise erklären',
      },
      'C1-C2': {
        label: 'Fortgeschritten',
        sublabel: 'Ich spreche in jeder Situation sicher, auch im Beruf',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Lebensstil',
        shopping: 'Einkaufen',
        cooking: 'Kochen',
        yoga: 'Yoga',
        fashion: 'Mode',
        fitness: 'Fitness',
        beauty: 'Beauty',
        pets: 'Haustiere',
        parenting: 'Elternschaft',
        food: 'Essen',
        dating: 'Dating',
        relationships: 'Beziehungen',
        cars: 'Autos',
      },
      artsCulture: {
        title: 'Kunst & Kultur',
        music: 'Musik',
        history: 'Geschichte',
        handcraft: 'Handarbeiten',
        literature: 'Literatur',
        art: 'Kunst',
        photography: 'Fotografie',
        content_creation: 'Content-Erstellung',
      },
      activeLife: {
        title: 'Aktives Leben',
        sports: 'Sport',
        travelling: 'Reisen',
        dancing: 'Tanzen',
        biking: 'Radfahren',
        football: 'Fußball',
        weight_lifting: 'Fitnessstudio',
        hiking: 'Wandern',
        running: 'Laufen',
        swimming: 'Schwimmen',
      },
      entertainment: {
        title: 'Unterhaltung',
        movies: 'Filme',
        tv_shows: 'Serien',
        gaming: 'Gaming',
        social_media: 'Social Media',
        podcasts: 'Podcasts',
        chatting: 'Chatten',
        news: 'Nachrichten',
        anime: 'Anime',
        sci_fi: 'Sci-Fi',
        fantasy: 'Fantasy',
        comedy: 'Komödien',
        horror: 'Horror',
        memes: 'Memes',
      },
      workGrowth: {
        title: 'Arbeit & Entwicklung',
        interview: 'Vorstellungsgespräche',
        tech: 'Technologie',
        finance: 'Finanzen',
        management: 'Management',
        ai: 'AI',
        business: 'Business',
        startups: 'Startups',
      },
    },
    agreementChoices: {
      yes: 'Ja',
      maybe: 'Vielleicht',
      no: 'Nein',
    },
  },
  pt: {
    goals: {
      confidence_work: 'Falar com mais confiança no trabalho',
      new_job: 'Encontrar um novo emprego',
      live_abroad: 'Viver tranquilo no exterior',
      travel: 'Viajar sem barreiras',
      self_growth: 'Desenvolver a habilidade para mim',
      connect: 'Conectar com amigos e família',
    },
    speakingDifficulties: {
      freeze: 'Eu travo e fico em silêncio',
      find_words: 'Não consigo achar as palavras certas',
      grammar: 'Tenho medo de errar a gramática',
      slow: 'Demoro muito para formular uma resposta',
      accent: 'As pessoas têm dificuldade de entender minha pronúncia',
      none: 'Nada disso',
    },
    dailyUsage: {
      news: 'Leio notícias',
      shows: 'Assisto a séries e vídeos',
      music: 'Escuto música e podcasts',
      work: 'Uso no trabalho',
      chat: 'Converso com falantes nativos',
      rarely: 'Quase não uso',
    },
    workFields: {
      tech: 'TI e engenharia',
      business: 'Negócios e finanças',
      education: 'Estudos / educação',
      creative: 'Criatividade e mídia',
      services: 'Serviços e ofícios',
      marketing: 'Marketing e vendas',
      healthcare: 'Saúde e ciência',
      unemployed: 'Atualmente sem trabalho',
      other: 'Outro',
    },
    ageRanges: {
      lt18: 'Menos de 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Masculino',
      female: 'Feminino',
      skip: 'Tanto faz',
    },
    currentMethods: {
      courses: 'Cursos ou um tutor',
      apps: 'Aplicativos de idiomas',
      videos: 'Vídeos e filmes',
      podcasts: 'Podcasts e audiolivros',
      speaking: 'Prática de conversação',
      none: 'Não estou estudando agora',
    },
    challenges: {
      time: 'Falta de tempo',
      motivation: 'Difícil manter a motivação',
      few_chances: 'Poucas chances de falar',
      forget: 'Esqueço o que aprendi',
      nervous: 'Fico nervoso ao falar',
      too_hard: 'O idioma parece difícil demais',
      none: 'Nenhuma dificuldade real',
    },
    speakingFeelings: {
      anxious: 'Fico ansioso e suando',
      freeze: 'Travo e esqueço as palavras',
      avoid: 'Tento evitar situações em que tenho que falar',
      embarrassed: 'Eu falo, mas sinto vergonha',
      confident: 'Me sinto confiante',
    },
    mistakeFears: {
      a_lot: 'Sim, muito — por isso prefiro ficar em silêncio',
      a_little: 'Um pouco, às vezes é constrangedor',
      no: 'Não, erros não me assustam',
    },
    vocabGaps: {
      often: 'Sim, muitas vezes fico sem palavras',
      sometimes: 'Às vezes',
      no: 'Não, tenho palavras suficientes',
    },
    progressQuits: {
      many_times: 'Sim, mais de uma vez',
      once: 'Aconteceu uma vez',
      no: 'Não, nunca',
    },
    hardestParts: {
      starting: 'Começar uma conversa',
      flow: 'Falar sem travar',
      words: 'Achar as palavras certas rapidamente',
      accents: 'Entender diferentes sotaques',
      complex: 'Expressar pensamentos complexos',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Iniciante',
        sublabel: 'Consigo fazer compras e pedir comida',
      },
      B1: {
        label: 'Intermediário',
        sublabel: 'Consigo manter uma conversa simples do dia a dia',
      },
      B2: {
        label: 'Intermediário superior',
        sublabel: 'Consigo participar de uma discussão e explicar meu ponto de vista',
      },
      'C1-C2': {
        label: 'Avançado',
        sublabel: 'Falo com confiança em qualquer situação, incluindo no trabalho',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Estilo de vida',
        shopping: 'Compras',
        cooking: 'Culinária',
        yoga: 'Yoga',
        fashion: 'Moda',
        fitness: 'Fitness',
        beauty: 'Beleza',
        pets: 'Pets',
        parenting: 'Criação dos filhos',
        food: 'Comida',
        dating: 'Namoro',
        relationships: 'Relacionamentos',
        cars: 'Carros',
      },
      artsCulture: {
        title: 'Arte e cultura',
        music: 'Música',
        history: 'História',
        handcraft: 'Artesanato',
        literature: 'Literatura',
        art: 'Arte',
        photography: 'Fotografia',
        content_creation: 'Criação de conteúdo',
      },
      activeLife: {
        title: 'Vida ativa',
        sports: 'Esporte',
        travelling: 'Viagens',
        dancing: 'Dança',
        biking: 'Ciclismo',
        football: 'Futebol',
        weight_lifting: 'Academia',
        hiking: 'Trilhas',
        running: 'Corrida',
        swimming: 'Natação',
      },
      entertainment: {
        title: 'Entretenimento',
        movies: 'Filmes',
        tv_shows: 'Séries',
        gaming: 'Games',
        social_media: 'Redes sociais',
        podcasts: 'Podcasts',
        chatting: 'Bate-papo',
        news: 'Notícias',
        anime: 'Anime',
        sci_fi: 'Ficção científica',
        fantasy: 'Fantasia',
        comedy: 'Comédias',
        horror: 'Terror',
        memes: 'Memes',
      },
      workGrowth: {
        title: 'Trabalho e desenvolvimento',
        interview: 'Entrevistas',
        tech: 'Tecnologia',
        finance: 'Finanças',
        management: 'Gestão',
        ai: 'AI',
        business: 'Negócios',
        startups: 'Startups',
      },
    },
    agreementChoices: {
      yes: 'Sim',
      maybe: 'Talvez',
      no: 'Não',
    },
  },
  fr: {
    goals: {
      confidence_work: 'Parler plus sûrement au travail',
      new_job: 'Trouver un nouveau travail',
      live_abroad: 'Vivre confortablement à l’étranger',
      travel: 'Voyager librement',
      self_growth: 'Développer la compétence pour moi',
      connect: 'Rester en contact avec mes amis et ma famille',
    },
    speakingDifficulties: {
      freeze: 'Je bloque et je me tais',
      find_words: 'Je ne trouve pas les bons mots',
      grammar: 'J’ai peur de faire des fautes de grammaire',
      slow: 'Il me faut beaucoup de temps pour formuler une réponse',
      accent: 'Les gens ont du mal à comprendre ma prononciation',
      none: 'Rien de tout ça',
    },
    dailyUsage: {
      news: 'Je lis les actualités',
      shows: 'Je regarde des séries et des vidéos',
      music: 'J’écoute de la musique et des podcasts',
      work: 'Je l’utilise au travail',
      chat: 'Je discute avec des natifs',
      rarely: 'Je l’utilise à peine',
    },
    workFields: {
      tech: 'IT et ingénierie',
      business: 'Business et finance',
      education: 'Études / éducation',
      creative: 'Créatif et médias',
      services: 'Services et artisanat',
      marketing: 'Marketing et ventes',
      healthcare: 'Santé et science',
      unemployed: 'Actuellement sans emploi',
      other: 'Autre',
    },
    ageRanges: {
      lt18: 'Moins de 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Masculin',
      female: 'Féminin',
      skip: 'Peu importe',
    },
    currentMethods: {
      courses: 'Des cours ou un tuteur',
      apps: 'Applis d’apprentissage des langues',
      videos: 'Vidéos et films',
      podcasts: 'Podcasts et livres audio',
      speaking: 'Pratique orale',
      none: 'Je n’apprends pas en ce moment',
    },
    challenges: {
      time: 'Pas assez de temps',
      motivation: 'Difficile de garder la motivation',
      few_chances: 'Peu d’occasions de parler',
      forget: 'J’oublie ce que j’ai appris',
      nervous: 'Je stresse quand je parle',
      too_hard: 'La langue me semble trop difficile',
      none: 'Pas de vraies difficultés',
    },
    speakingFeelings: {
      anxious: 'Je stresse et je transpire',
      freeze: 'Je bloque et j’oublie les mots',
      avoid: 'J’essaie d’éviter les situations où il faut parler',
      embarrassed: 'Je parle, mais ça me gêne',
      confident: 'Je me sens à l’aise',
    },
    mistakeFears: {
      a_lot: 'Oui, beaucoup — alors je préfère me taire',
      a_little: 'Un peu, ça met mal à l’aise',
      no: 'Non, les erreurs ne me font pas peur',
    },
    vocabGaps: {
      often: 'Oui, il me manque souvent des mots',
      sometimes: 'Parfois',
      no: 'Non, j’ai assez de mots',
    },
    progressQuits: {
      many_times: 'Oui, plus d’une fois',
      once: 'C’est arrivé une fois',
      no: 'Non, jamais',
    },
    hardestParts: {
      starting: 'Commencer une conversation',
      flow: 'Parler sans bloquer',
      words: 'Trouver vite les bons mots',
      accents: 'Comprendre différents accents',
      complex: 'Exprimer des pensées complexes',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Débutant',
        sublabel: 'Je peux faire des achats et commander à manger',
      },
      B1: {
        label: 'Intermédiaire',
        sublabel: 'Je peux tenir une conversation simple au quotidien',
      },
      B2: {
        label: 'Intermédiaire supérieur',
        sublabel: 'Je peux participer à une discussion et expliquer mon point de vue',
      },
      'C1-C2': {
        label: 'Avancé',
        sublabel: 'Je parle avec assurance dans toutes les situations, y compris au travail',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Style de vie',
        shopping: 'Shopping',
        cooking: 'Cuisine',
        yoga: 'Yoga',
        fashion: 'Mode',
        fitness: 'Fitness',
        beauty: 'Beauté',
        pets: 'Animaux',
        parenting: 'Parentalité',
        food: 'Nourriture',
        dating: 'Rencontres',
        relationships: 'Relations',
        cars: 'Voitures',
      },
      artsCulture: {
        title: 'Arts et culture',
        music: 'Musique',
        history: 'Histoire',
        handcraft: 'Artisanat',
        literature: 'Littérature',
        art: 'Art',
        photography: 'Photographie',
        content_creation: 'Création de contenu',
      },
      activeLife: {
        title: 'Vie active',
        sports: 'Sport',
        travelling: 'Voyages',
        dancing: 'Danse',
        biking: 'Cyclisme',
        football: 'Football',
        weight_lifting: 'Salle de sport',
        hiking: 'Randonnée',
        running: 'Course à pied',
        swimming: 'Natation',
      },
      entertainment: {
        title: 'Divertissement',
        movies: 'Films',
        tv_shows: 'Séries',
        gaming: 'Jeux vidéo',
        social_media: 'Réseaux sociaux',
        podcasts: 'Podcasts',
        chatting: 'Discussions',
        news: 'Actualités',
        anime: 'Anime',
        sci_fi: 'Science-fiction',
        fantasy: 'Fantasy',
        comedy: 'Comédies',
        horror: 'Horreur',
        memes: 'Mèmes',
      },
      workGrowth: {
        title: 'Travail et développement',
        interview: 'Entretiens',
        tech: 'Technologie',
        finance: 'Finance',
        management: 'Management',
        ai: 'AI',
        business: 'Business',
        startups: 'Startups',
      },
    },
    agreementChoices: {
      yes: 'Oui',
      maybe: 'Peut-être',
      no: 'Non',
    },
  },
  es: {
    goals: {
      confidence_work: 'Hablar con más confianza en el trabajo',
      new_job: 'Buscar un nuevo trabajo',
      live_abroad: 'Vivir cómodamente en el extranjero',
      travel: 'Viajar sin barreras',
      self_growth: 'Desarrollar la habilidad para mí',
      connect: 'Conectar con amigos y familia',
    },
    speakingDifficulties: {
      freeze: 'Me bloqueo y me quedo en silencio',
      find_words: 'No encuentro las palabras correctas',
      grammar: 'Tengo miedo de cometer errores de gramática',
      slow: 'Tardo mucho en formular una respuesta',
      accent: 'A la gente le cuesta entender mi pronunciación',
      none: 'Nada de esto',
    },
    dailyUsage: {
      news: 'Leo noticias',
      shows: 'Veo series y videos',
      music: 'Escucho música y podcasts',
      work: 'Lo uso en el trabajo',
      chat: 'Chateo con hablantes nativos',
      rarely: 'Casi no lo uso',
    },
    workFields: {
      tech: 'IT e ingeniería',
      business: 'Negocios y finanzas',
      education: 'Estudios / educación',
      creative: 'Creatividad y medios',
      services: 'Servicios y oficios',
      marketing: 'Marketing y ventas',
      healthcare: 'Salud y ciencia',
      unemployed: 'Actualmente sin trabajo',
      other: 'Otro',
    },
    ageRanges: {
      lt18: 'Menos de 18',
      '18-24': '18–24',
      '25-34': '25–34',
      '35-44': '35–44',
      '45+': '45+',
    },
    genders: {
      male: 'Masculino',
      female: 'Femenino',
      skip: 'Da igual',
    },
    currentMethods: {
      courses: 'Cursos o un tutor',
      apps: 'Apps para aprender idiomas',
      videos: 'Videos y películas',
      podcasts: 'Podcasts y audiolibros',
      speaking: 'Práctica de conversación',
      none: 'Ahora no estudio',
    },
    challenges: {
      time: 'Falta de tiempo',
      motivation: 'Cuesta mantener la motivación',
      few_chances: 'Pocas oportunidades de hablar',
      forget: 'Olvido lo que aprendí',
      nervous: 'Me pongo nervioso al hablar',
      too_hard: 'El idioma me parece demasiado difícil',
      none: 'Ninguna dificultad real',
    },
    speakingFeelings: {
      anxious: 'Me pongo nervioso y sudo',
      freeze: 'Me bloqueo y olvido las palabras',
      avoid: 'Intento evitar situaciones en las que tengo que hablar',
      embarrassed: 'Hablo, pero me da vergüenza',
      confident: 'Me siento seguro',
    },
    mistakeFears: {
      a_lot: 'Sí, mucho — por eso prefiero quedarme en silencio',
      a_little: 'Un poco, a veces es incómodo',
      no: 'No, los errores no me asustan',
    },
    vocabGaps: {
      often: 'Sí, a menudo me faltan palabras',
      sometimes: 'A veces',
      no: 'No, tengo palabras suficientes',
    },
    progressQuits: {
      many_times: 'Sí, más de una vez',
      once: 'Pasó una vez',
      no: 'No, nunca',
    },
    hardestParts: {
      starting: 'Empezar una conversación',
      flow: 'Hablar sin atascos',
      words: 'Encontrar rápido las palabras correctas',
      accents: 'Entender diferentes acentos',
      complex: 'Expresar pensamientos complejos',
    },
    cefrLevels: {
      'A1-A2': {
        label: 'Principiante',
        sublabel: 'Puedo hacer compras y pedir comida',
      },
      B1: {
        label: 'Intermedio',
        sublabel: 'Puedo mantener una conversación sencilla del día a día',
      },
      B2: {
        label: 'Intermedio alto',
        sublabel: 'Puedo participar en una discusión y explicar mi punto de vista',
      },
      'C1-C2': {
        label: 'Avanzado',
        sublabel: 'Hablo con confianza en cualquier situación, incluido el trabajo',
      },
    },
    interestGroups: {
      lifestyle: {
        title: 'Estilo de vida',
        shopping: 'Compras',
        cooking: 'Cocina',
        yoga: 'Yoga',
        fashion: 'Moda',
        fitness: 'Fitness',
        beauty: 'Belleza',
        pets: 'Mascotas',
        parenting: 'Crianza de los hijos',
        food: 'Comida',
        dating: 'Citas',
        relationships: 'Relaciones',
        cars: 'Coches',
      },
      artsCulture: {
        title: 'Arte y cultura',
        music: 'Música',
        history: 'Historia',
        handcraft: 'Manualidades',
        literature: 'Literatura',
        art: 'Arte',
        photography: 'Fotografía',
        content_creation: 'Creación de contenido',
      },
      activeLife: {
        title: 'Vida activa',
        sports: 'Deporte',
        travelling: 'Viajes',
        dancing: 'Baile',
        biking: 'Ciclismo',
        football: 'Fútbol',
        weight_lifting: 'Gimnasio',
        hiking: 'Senderismo',
        running: 'Correr',
        swimming: 'Natación',
      },
      entertainment: {
        title: 'Entretenimiento',
        movies: 'Películas',
        tv_shows: 'Series',
        gaming: 'Videojuegos',
        social_media: 'Redes sociales',
        podcasts: 'Podcasts',
        chatting: 'Charlar',
        news: 'Noticias',
        anime: 'Anime',
        sci_fi: 'Ciencia ficción',
        fantasy: 'Fantasía',
        comedy: 'Comedias',
        horror: 'Terror',
        memes: 'Memes',
      },
      workGrowth: {
        title: 'Trabajo y desarrollo',
        interview: 'Entrevistas',
        tech: 'Tecnología',
        finance: 'Finanzas',
        management: 'Gestión',
        ai: 'AI',
        business: 'Negocios',
        startups: 'Startups',
      },
    },
    agreementChoices: {
      yes: 'Sí',
      maybe: 'Quizás',
      no: 'No',
    },
  },
};
